import React from 'react';
import NavList from 'components/MainMenu/NavList';
import PropTypes from 'prop-types';

const Menu = ({ show, items }) => {
  if (!show && !items) return null;
  return <NavList navItems={items} />;
};

Menu.propTypes = {
  show: PropTypes.bool,
  items: PropTypes.array
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/MainMenu/Menu.js